import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectorsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: 26,
		width: 26,
		height: 26,
		rx: 3,
		transform: "rotate(-90 0 26)",
		fill: "#10B2FB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 17L9 21L9 17.8L13.8 17.8L13.8 16.2L9 16.2L9 13L5 17ZM5.8 9.8L7.4 9.8L7.4 8.2L5.8 8.2L5.8 9.8ZM9 9.8L10.6 9.8L10.6 8.2L9 8.2L9 9.8ZM12.2 9.8L17 9.8L17 13L21 9L17 5L17 8.2L12.2 8.2L12.2 9.8ZM15.4 17.8L17 17.8L17 16.2L15.4 16.2L15.4 17.8ZM18.6 17.8L20.2 17.8L20.2 16.2L18.6 16.2L18.6 17.8Z",
		fill: "white"
	})]
});
export default SvgConnectorsIcon;
